module.exports = __webpack_public_path__ + "img/add__card__modal.913b6bca.png";